import { useCallback, useMemo } from "react";
import moment from "moment";
import { useAppSelector } from "store/hooks";
import shopSelectors from "store/shop/selectors";
import { ANYONE } from "./anyone";
import { CalendarDataItem } from "types/models";

export interface CalendarHeader {
  id: string;
  value: string;
  label: string;
  type: 'staff';
  url?: string;
  typeColor: number;
}

export interface CalendarSchema {
  dateFilter?: moment.Moment;
  headers: CalendarHeader[];
  filterAppointments: (order: CalendarDataItem, col: CalendarHeader) => boolean;
  timeHourEnd: number;
  timeHourStart: number;
  timeMinuteEnd: number;
  timeMinuteStart: number;
  distanceTimeline: number;
}

export interface UseCalendarSchemaProps {
  headers?: (string | number)[];
  dateFilter?: moment.Moment;
  staffView?: boolean;
}

const useCalendarSchema = ({ headers: staffHeaders = [], dateFilter, staffView = false }: UseCalendarSchemaProps): CalendarSchema => {
  const _staffListStore = useAppSelector(shopSelectors.staff);
  // optional chaining here comes from the mobile branch — keep its runtime behavior
  const staffList = useMemo(() => _staffListStore?.filter(o => staffHeaders.find(s => s?.toString() === o?.id?.toString())), [_staffListStore]);
  const headers = useMemo((): CalendarHeader[] => {
    let _headers: CalendarHeader[] = [
      { id: ANYONE.id, value: ANYONE.id, label: ANYONE.name, type: 'staff', url: ANYONE.avatar, typeColor: 0 }
    ];
    if (staffView) {
      _headers = [];
    }
    let i = 1;
    staffList.forEach((item) => {
      const result: CalendarHeader = ({
        id: item.id,
        value: item.id,
        label: item.name,
        type: 'staff',
        url: item.avatar,
        typeColor: i,
      });
      i++;
      if (i > 6) {
        i = 1;
      }
      _headers.push(result);
    });

    return _headers;
  }, [staffList, _staffListStore, staffView]);

  const filterAppointments = useCallback((order: CalendarDataItem, _col: CalendarHeader) => {
    const staffId = order?.staffId;
    return staffId?.toString() === _col.id?.toString();
  }, []);

  return ({
    dateFilter,
    headers,
    filterAppointments,
    timeHourEnd: 21,
    timeHourStart: 9,
    timeMinuteEnd: 0,
    timeMinuteStart: 0,
    distanceTimeline: 15,
  })
};

export default useCalendarSchema;
